import { baseColors, darkThemeColors, lightThemeColors, ThemeColors } from './colors'

const lyraSelectBaseColors = {
  ...baseColors,

  // Component
  slider_background_tint_blue: '#01011F',
}

export const lyraSelectLightThemeColors: ThemeColors = {
  ...lightThemeColors,

  // Text
  textActive: lyraSelectBaseColors.blueberry_40,

  // Link
  linkDefault: lyraSelectBaseColors.blueberry_40,
  linkHover: lyraSelectBaseColors.blueberry_50,

  // Background
  backgroundHighlightPrimary: lyraSelectBaseColors.blueberry_10,
  backgroundActive: lyraSelectBaseColors.blueberry_40,
  backgroundHover: lyraSelectBaseColors.blueberry_50,
  backgroundPressed: lyraSelectBaseColors.blueberry_60,
  backgroundLoading: lyraSelectBaseColors.blueberry_60,
  backgroundTopMatch: lyraSelectBaseColors.blueberry_20,

  // Border
  borderHover: lyraSelectBaseColors.blueberry_40,
  borderFocus: lyraSelectBaseColors.blueberry_40,
  borderInput: lyraSelectBaseColors.blueberry_40,
  borderTopMatch: lyraSelectBaseColors.blueberry_20,

  // Icon
  iconActive: lyraSelectBaseColors.blueberry_40,

  // Primary button
  primaryButtonBackgroundDefault: lyraSelectBaseColors.blueberry_40,
  primaryButtonBackgroundHover: lyraSelectBaseColors.blueberry_50,
  primaryButtonBackgroundPressed: lyraSelectBaseColors.blueberry_60,
  primaryButtonBackgroundLoading: lyraSelectBaseColors.blueberry_60,
  primaryButtonBackgroundFocus: lyraSelectBaseColors.blueberry_50,

  secondaryButtonBackgroundHover: lyraSelectBaseColors.blueberry_10,
  secondaryButtonBackgroundPressed: lyraSelectBaseColors.blueberry_20,
  secondaryButtonBackgroundFocus: lyraSelectBaseColors.blueberry_10,
  secondaryButtonOutlineDefault: lyraSelectBaseColors.blueberry_40, // confirm this change
  secondaryButtonTextActive: lyraSelectBaseColors.blueberry_40, // confirm this change

  // Secondary button variants
  secondaryButtonInverseBackgroundHover: lyraSelectBaseColors.blueberry_60,
  secondaryButtonInverseBackgroundPressed: lyraSelectBaseColors.blueberry_60,
  secondaryButtonInverseBackgroundFocus: lyraSelectBaseColors.blueberry_60,
  secondaryButtonInverseOutlineDefault: lyraSelectBaseColors.blueberry_20,
  secondaryButtonInverseOutlinePressed: lyraSelectBaseColors.blueberry_40,
  secondaryButtonInverseTextActive: lyraSelectBaseColors.blueberry_20,

  wordCloudButtonBackgroundSelected: lyraSelectBaseColors.blueberry_10,
  wordCloudButtonOutlineHover: lyraSelectBaseColors.blueberry_40,
  wordCloudButtonOutlinePressed: lyraSelectBaseColors.blueberry_40,
  wordCloudButtonOutlineSelected: lyraSelectBaseColors.blueberry_40,
  wordCloudButtonTextPressed: lyraSelectBaseColors.blueberry_50,
  wordCloudButtonTextSelected: lyraSelectBaseColors.blueberry_50,

  // Input field
  inputOutlineSelected: lyraSelectBaseColors.blueberry_20,
  inputOutlineHover: lyraSelectBaseColors.blueberry_40,
  inputOutlineFocus: lyraSelectBaseColors.blueberry_40,
  inputBackgroundDefault: lyraSelectBaseColors.white,
  inputBackgroundTriageDefault: lyraSelectBaseColors.white,

  // Typeahead
  typeaheadMenuBackground: lyraSelectBaseColors.blueberry_0,
  typeaheadItemBackgroundHover: baseColors.oatmeal_15,

  // Checkbox
  checkboxBackgroundPrimarySelected: lyraSelectBaseColors.blueberry_10,
  checkboxBackgroundSelected: lyraSelectBaseColors.blueberry_40,
  checkboxBackgroundPressed: lyraSelectBaseColors.blueberry_40,
  checkboxOutlineSelected: lyraSelectBaseColors.blueberry_40,
  checkboxOutlineHovered: lyraSelectBaseColors.blueberry_40,
  checkboxTextDefault: baseColors.oatmeal_60,
  checkboxTextSelected: lyraSelectBaseColors.blueberry_40,

  // Radio
  radioBackgroundSelected: lyraSelectBaseColors.blueberry_40,
  radioBackgroundSelectedInactive: lyraSelectBaseColors.blueberry_20,
  radioTextSelected: lyraSelectBaseColors.blueberry_50,
  radioOutlineSelected: lyraSelectBaseColors.blueberry_40,
  radioOutlineSelectedInactive: lyraSelectBaseColors.blueberry_20,
  radioOutlineFocused: lyraSelectBaseColors.blueberry_40,

  // Radio with outline
  radioWithOutlinePrimaryTextHighlight: lyraSelectBaseColors.blueberry_60,
  radioWithOutlineBackgroundSelected: lyraSelectBaseColors.blueberry_10,
  radioWithOutlineBorderSelected: lyraSelectBaseColors.blueberry_40,
  radioWithOutlinePrimaryTextSelected: lyraSelectBaseColors.blueberry_50,
  radioWithOutlineSecondaryTextSelected: lyraSelectBaseColors.blueberry_40,
  radioWithOutlineBorderHovered: lyraSelectBaseColors.blueberry_40,
  radioWithOutlineBorderInactive: lyraSelectBaseColors.blueberry_20,

  // Progress indicator
  progressIndicator: lyraSelectBaseColors.blueberry_30,
  progressIndicatorBackgroundTop: lyraSelectBaseColors.white,
  progressIndicatorBackgroundBottom: lyraSelectBaseColors.white,

  // ScrollView Refresher
  scrollViewRefresherLoadingIcon: lyraSelectBaseColors.blueberry_30,

  // Gradient Tokens
  gradientBubbleStart: lyraSelectBaseColors.blueberry_10,
  gradientBubbleEnd: lyraSelectBaseColors.blueberry_0,

  // Page background gradient tokens
  backgroundGradientFirst: lyraSelectBaseColors.blueberry_10,

  // Tooltip
  backgroundTooltip: lyraSelectBaseColors.blueberry_60,

  // Carousel button
  carouselButtonFilledBackgroundActive: lyraSelectBaseColors.blueberry_40,
  carouselButtonFilledBackgroundHover: lyraSelectBaseColors.blueberry_50,
  carouselButtonFilledBackgroundPressed: lyraSelectBaseColors.blueberry_60,
  carouselButtonFilledBackgroundFocus: lyraSelectBaseColors.blueberry_50,

  components: {
    ...lightThemeColors.components,
    activityHeader: {
      headline: {
        border: lyraSelectBaseColors.blueberry_30,
      },
    },
    badge: {
      ...lightThemeColors.components.badge,
      // Lyra Select specific badge colors (swapped infoPrimary and infoSecondary)
      infoPrimary: {
        background: lightThemeColors.components.badge.infoSecondary.background,
        text: lightThemeColors.components.badge.infoSecondary.text,
      },
      infoSecondary: {
        background: lightThemeColors.components.badge.infoPrimary.background,
        text: lightThemeColors.components.badge.infoPrimary.text,
      },
      inverse: {
        background: lightThemeColors.components.badge.inverse.background,
        text: lightThemeColors.components.badge.infoSecondary.text,
      },
    },
    alertBanner: {
      ...lightThemeColors.components.alertBanner,
      calm: {
        ...lightThemeColors.components.alertBanner.calm,
        background: lyraSelectBaseColors.blueberry_60,
      },
    },
    avatar: {
      ...lightThemeColors.components.avatar,
      tealTheme: { background: lyraSelectBaseColors.blueberry_10, text: lyraSelectBaseColors.blueberry_50 },
    },
    chatBubble: {
      ...lightThemeColors.components.chatBubble,
      outOfOffice: {
        ...lightThemeColors.components.chatBubble.outOfOffice,
        background: lyraSelectBaseColors.blueberry_40,
      },
    },
    coachMark: {
      background: lyraSelectBaseColors.blueberry_60,
      arrow: {
        border: lyraSelectBaseColors.blueberry_60,
      },
    },
    dateBlock: {
      border: lyraSelectBaseColors.blueberry_40,
      text: lyraSelectBaseColors.blueberry_40,
      background: lyraSelectBaseColors.blueberry_10,
    },
    feedbackStarIcon: {
      ...lightThemeColors.components.feedbackStarIcon,
      default: {
        ...lightThemeColors.components.feedbackStarIcon.default,
        hover: {
          ...lightThemeColors.components.feedbackStarIcon.default.hover,
          border: lyraSelectBaseColors.blueberry_40,
        },
        highlighted: {
          fill: lyraSelectBaseColors.blueberry_40,
          border: lyraSelectBaseColors.blueberry_40,
        },
      },
    },
    focusBoxShadow: {
      ...lightThemeColors.components.focusBoxShadow,
      outerBox: { fill: lyraSelectBaseColors.blueberry_40 },
    },
    genericHeader: {
      background: lyraSelectBaseColors.blueberry_60,
    },
    lessonPreview: {
      ...lightThemeColors.components.lessonPreview,
      progressBar: {
        fill: lyraSelectBaseColors.blueberry_40,
      },
    },
    lessonThumbnail: {
      iconDisplay: {
        background: lyraSelectBaseColors.blueberry_20,
        fill: lyraSelectBaseColors.blueberry_40,
      },
      disabledIcon: {
        fill: lyraSelectBaseColors.blueberry_30,
      },
      progressBar: {
        fill: lyraSelectBaseColors.blueberry_40,
      },
    },
    messageAttachment: {
      innerContainer: {
        background: lyraSelectBaseColors.blueberry_50,
      },
    },
    messageItem: {
      ...lightThemeColors.components.messageItem,
      chatBubbleSender: {
        background: lyraSelectBaseColors.blueberry_50,
        border: lyraSelectBaseColors.blueberry_50,
      },
    },
    aiStatusBadge: {
      ...lightThemeColors.components.aiStatusBadge,
      processing: {
        background: lyraSelectBaseColors.blueberry_10,
        text: lyraSelectBaseColors.blueberry_50,
      },
    },
    notificationsOverview: {
      notificationIcon: {
        fill: lyraSelectBaseColors.blueberry_60,
      },
    },
    platformEngagementQuarterlyDetails: {
      text: lyraSelectBaseColors.blueberry_60,
    },
    privacyScreen: {
      textContainer: { background: lyraSelectBaseColors.blueberry_60 },
    },
    progressBar: {
      ...lightThemeColors.components.progressBar,
      fill: lyraSelectBaseColors.blueberry_20,
    },
    progressBarSecondary: {
      fill: lyraSelectBaseColors.blueberry_30,
      background: lyraSelectBaseColors.blueberry_20,
    },
    providerCalendar: {
      ...lightThemeColors.components.providerCalendar,
      event: {
        ...lightThemeColors.components.providerCalendar.event,
        bookableHover: {
          background: lyraSelectBaseColors.blueberry_10,
          border: lyraSelectBaseColors.blueberry_40,
        },
        recurringSession: {
          background: lyraSelectBaseColors.blueberry_20,
          border: lyraSelectBaseColors.blueberry_20,
          text: lyraSelectBaseColors.blueberry_60,
        },
        mirror: {
          background: lyraSelectBaseColors.blueberry_10,
          border: lyraSelectBaseColors.blueberry_40,
        },
      },
    },
    providerLanguagesSpoken: {
      ...lightThemeColors.components.providerLanguagesSpoken,
      textBadge: {
        text: lyraSelectBaseColors.blueberry_50,
      },
    },
    providerBadges: {
      ...lightThemeColors.components.providerBadges,
      preferenceMatchBadge: {
        checkIcon: { fill: lyraSelectBaseColors.blueberry_30 },
      },
    },
    s4cLoadingIndicator: {
      text: lyraSelectBaseColors.blueberry_60,
    },
    s4cHeader: {
      background: lyraSelectBaseColors.blueberry_10,
    },
    s4cTriageBackgroundHeader: {
      background: '#DAECFF',
    },
    s4cTriageMaximumSliderTint: { background: lyraSelectBaseColors.white },
    sliderField: {
      text: lyraSelectBaseColors.blueberry_50,
      thumb: {
        ...lightThemeColors.components.sliderField.thumb,
        border: lyraSelectBaseColors.blueberry_40,
      },
      track: {
        ...lightThemeColors.components.sliderField.track,
        minimumTint: {
          background: lyraSelectBaseColors.blueberry_40,
        },
      },
      stepMarker: {
        ...lightThemeColors.components.sliderField.stepMarker,
        filled: {
          background: lyraSelectBaseColors.blueberry_10,
        },
      },
      floatingLabel: {
        ...lightThemeColors.components.sliderField.floatingLabel,
        border: lyraSelectBaseColors.blueberry_40,
      },
    },
    multicolorSliderField: {
      ...lightThemeColors.components.multicolorSliderField,
      text: lyraSelectBaseColors.blueberry_50,
    },
    triageSummary: {
      ...lightThemeColors.components.triageSummary,
      badge: {
        background: lyraSelectBaseColors.blueberry_20,
        fill: lyraSelectBaseColors.blueberry_50,
      },
    },
    dotsPagination: {
      ...lightThemeColors.components.dotsPagination,
      activeDot: {
        fill: lyraSelectBaseColors.blueberry_30,
      },
    },
    toolbar: {
      background: lyraSelectBaseColors.blueberry_60,
    },
    treatmentCard: {
      ...lightThemeColors.components.treatmentCard,
      findCounsellorSection: {
        icon: {
          fill: lyraSelectBaseColors.blueberry_60,
        },
      },
    },
    unsupportedLanguageDisclaimer: {
      text: lyraSelectBaseColors.blueberry_50,
    },
    videoControlButton: {
      ...lightThemeColors.components.videoControlButton,
      disabledColor: {
        fill: lyraSelectBaseColors.blueberry_30,
      },
    },
    videoLessonComplete: {
      ...lightThemeColors.components.videoLessonComplete,
      check: { fill: lyraSelectBaseColors.blueberry_20 },
      completeText: { text: lyraSelectBaseColors.blueberry_20 },
    },
    videoPlayer: {
      ...lightThemeColors.components.videoPlayer,
      minimumTrackTint: { background: lyraSelectBaseColors.blueberry_20 },
    },
    welcomeSplashScreen: {
      backButton: { fill: lyraSelectBaseColors.blueberry_60 },
    },
    wellnessToolkitEssentials: {
      text: lyraSelectBaseColors.blueberry_50,
    },
    zoomParticipantStatus: {
      ...lightThemeColors.components.zoomParticipantStatus,
      ready: {
        ...lightThemeColors.components.zoomParticipantStatus.ready,
        background: lyraSelectBaseColors.blueberry_40,
      },
    },
    zoomVideoControls: {
      ...lightThemeColors.components.zoomVideoControls,
      disabled: { background: lyraSelectBaseColors.blueberry_40 },
    },
    onboardingNavBarDefaultBackground: {
      background: lyraSelectBaseColors.oatmeal_10,
    },
  },
  icons: {
    ...lightThemeColors.icons,
    appIcon: {
      ...lightThemeColors.icons.appIcon,
      background: lyraSelectBaseColors.blueberry_60,
    },
    avatarIcon: {
      body: { fill: lyraSelectBaseColors.blueberry_10 },
      shadow: { fill: lyraSelectBaseColors.blueberry_20 },
      fill: lyraSelectBaseColors.blueberry_30,
    },
    checkMarkIcon: {
      fill: lyraSelectBaseColors.blueberry_30,
    },
    essentialsIcon: {
      fill: lyraSelectBaseColors.blueberry_60,
    },
    fingerprintIcon: {
      fill: lyraSelectBaseColors.blueberry_20,
    },
    linkIcon: {
      chain: { fill: lyraSelectBaseColors.blueberry_30 },
    },
    liveChatMessagingIcon: {
      fill: lyraSelectBaseColors.blueberry_10,
    },
    logoutIcon: {
      rectangle: { fill: lyraSelectBaseColors.blueberry_20 },
      arrow: { fill: lyraSelectBaseColors.blueberry_40 },
    },
    menuIcon: {
      fill: lyraSelectBaseColors.blueberry_60,
    },
    messagingIcon: {
      border: lyraSelectBaseColors.blueberry_60,
    },
    notificationIcon: {
      fill: lyraSelectBaseColors.blueberry_30,
    },
    progressIcon: {
      fill: lyraSelectBaseColors.blueberry_60,
    },
    scoringIcon: {
      ...lightThemeColors.icons.scoringIcon,
      neutral: {
        arrow: { fill: lyraSelectBaseColors.blueberry_40 },
        stroke: { fill: lyraSelectBaseColors.blueberry_20 },
        fill: lyraSelectBaseColors.blueberry_10,
      },
    },
    selfCareIcon: {
      ...lightThemeColors.icons.selfCareIcon,
      fill: lyraSelectBaseColors.blueberry_30,
    },
    sessionIcon: {
      fill: lyraSelectBaseColors.blueberry_60,
    },
    timeIcon: {
      background: lyraSelectBaseColors.blueberry_10,
      clockHandBackground: {
        fill: lyraSelectBaseColors.blueberry_20,
      },
      clockHandForeground: {
        fill: lyraSelectBaseColors.blueberry_30,
      },
    },
  },
}

// TODO Wait for design for dark theme colors for lyra select
export const lyraSelectDarkThemeColors: ThemeColors = {
  ...darkThemeColors,
  backgroundTooltip: lyraSelectBaseColors.blueberry_10,
  backgroundPrimary: lyraSelectBaseColors.blueberry_70,
  backgroundHighlightPrimary: '#192257',
  backgroundSecondary: lyraSelectBaseColors.blueberry_75,
  backgroundSection: lyraSelectBaseColors.blueberry_75,
  backgroundActive: lyraSelectBaseColors.blueberry_40,
  backgroundElement: lyraSelectBaseColors.blueberry_70,
  backgroundTopMatch: lyraSelectBaseColors.blueberry_65,
  backgroundModal: lyraSelectBaseColors.blueberry_70,
  backgroundSurfaceElement: lyraSelectBaseColors.blueberry_70,

  backgroundNavHeader: lyraSelectBaseColors.blueberry_80,

  textActive: lyraSelectBaseColors.blueberry_25,

  iconActive: lyraSelectBaseColors.blueberry_25,
  iconDefault: lyraSelectBaseColors.blueberry_50,

  inputBackgroundDefault: lyraSelectBaseColors.blueberry_75,
  inputBackgroundTriageDefault: lyraSelectBaseColors.blueberry_75,
  inputOutlineDefault: lyraSelectBaseColors.blueberry_50,
  inputOutlineTriageDefault: lyraSelectBaseColors.blueberry_50,
  inputOutlineFocus: lyraSelectBaseColors.blueberry_30,

  primaryButtonBackgroundDefault: lyraSelectBaseColors.blueberry_40,
  primaryButtonBackgroundLoading: lyraSelectBaseColors.blueberry_30,
  primaryButtonBackgroundPressed: lyraSelectBaseColors.blueberry_30,
  primaryButtonBackgroundFocus: lyraSelectBaseColors.blueberry_30,
  primaryButtonBackgroundHover: lyraSelectBaseColors.blueberry_50,

  dividerSecondary: lyraSelectBaseColors.blueberry_50,

  secondaryButtonBackgroundPressed: lyraSelectBaseColors.blueberry_30,
  secondaryButtonTextActive: lyraSelectBaseColors.blueberry_25,
  secondaryButtonOutlineDefault: lyraSelectBaseColors.blueberry_25,
  carouselButtonFilledBackgroundHover: lyraSelectBaseColors.blueberry_50,

  carouselButtonFilledBackgroundActive: lyraSelectBaseColors.blueberry_40,

  // Word cloud button tokens
  wordCloudButtonBackgroundDefault: lyraSelectBaseColors.blueberry_70,
  wordCloudButtonBackgroundSelected: lyraSelectBaseColors.blueberry_60,
  wordCloudButtonOutlineDefault: lyraSelectBaseColors.blueberry_50,
  wordCloudButtonOutlinePressed: lyraSelectBaseColors.blueberry_30,
  wordCloudButtonOutlineSelected: lyraSelectBaseColors.blueberry_30,

  // Cards
  cardBackgroundPrimary: lyraSelectBaseColors.blueberry_70,
  cardOutlinePrimary: lyraSelectBaseColors.blueberry_50,

  linkDefault: lyraSelectBaseColors.blueberry_25,

  borderDefault: lyraSelectBaseColors.blueberry_50,
  borderAccent: lyraSelectBaseColors.blueberry_40,
  borderFocus: lyraSelectBaseColors.blueberry_30,

  dividerPrimary: lyraSelectBaseColors.blueberry_50,

  progressIndicator: lyraSelectBaseColors.blueberry_30,

  radioWithOutlineBackgroundDefault: lyraSelectBaseColors.blueberry_75,
  radioWithOutlineBorderDefault: lyraSelectBaseColors.blueberry_50,
  radioWithOutlineBorderSelected: lyraSelectBaseColors.blueberry_30,
  radioWithOutlineBackgroundSelected: lyraSelectBaseColors.blueberry_60,
  radioWithOutlineBorderHovered: lyraSelectBaseColors.blueberry_40,
  radioOutlineDefault: lyraSelectBaseColors.blueberry_50,
  radioOutlineSelected: lyraSelectBaseColors.blueberry_30,
  radioBackgroundPrimary: lyraSelectBaseColors.blueberry_75,
  radioBackgroundSelected: '#DBE4FF',
  radioTextSelected: '#DBE4FF',

  checkboxBackgroundPrimarySelected: '#192257',
  checkboxOutlineDefault: lyraSelectBaseColors.blueberry_50,
  checkboxOutlineSelected: lyraSelectBaseColors.blueberry_30,
  checkboxOutlineHovered: lyraSelectBaseColors.blueberry_30,
  checkboxBackgroundSelected: lyraSelectBaseColors.blueberry_60,
  checkboxCheckSelected: lyraSelectBaseColors.blueberry_30,
  checkboxTextDefault: baseColors.oatmeal_30,
  checkboxTextSelected: lyraSelectBaseColors.blueberry_25,

  // Typeahead
  typeaheadMenuBackground: lyraSelectBaseColors.blueberry_75,
  typeaheadItemBackgroundHover: baseColors.oatmeal_50,

  // Skeleton tokens
  skeletonBoneColor: lyraSelectBaseColors.blueberry_70,
  skeletonHighlightColor: lyraSelectBaseColors.blueberry_65,

  components: {
    ...darkThemeColors.components,
    avatar: {
      ...darkThemeColors.components.avatar,
      tealTheme: { background: lyraSelectBaseColors.blueberry_10, text: lyraSelectBaseColors.blueberry_50 },
    },
    badge: {
      ...darkThemeColors.components.badge,
      // Lyra Select specific badge colors for dark mode (swapped infoPrimary and infoSecondary, plus neutral changes)
      neutral: {
        background: lyraSelectBaseColors.status_periwinkle_60,
        text: lyraSelectBaseColors.peri_20,
      },
      infoPrimary: {
        background: darkThemeColors.components.badge.infoSecondary.background,
        text: darkThemeColors.components.badge.infoSecondary.text,
      },
      infoSecondary: {
        background: darkThemeColors.components.badge.infoPrimary.background,
        text: darkThemeColors.components.badge.infoPrimary.text,
      },
      inverse: {
        background: lyraSelectBaseColors.status_periwinkle_80,
        text: lyraSelectBaseColors.peri_20,
      },
      neutralTransparent: {
        background: darkThemeColors.components.badge.neutralTransparent.background,
        text: lyraSelectBaseColors.peri_20,
      },
    },
    wellnessToolkitEssentials: {
      text: lyraSelectBaseColors.blueberry_25,
    },
    bottomTabBar: {
      background: lyraSelectBaseColors.blueberry_80,
    },
    dotsPagination: {
      ...darkThemeColors.components.dotsPagination,
      activeDot: { fill: lyraSelectBaseColors.blueberry_40 },
    },
    lessonThumbnail: {
      iconDisplay: {
        background: lyraSelectBaseColors.blueberry_50,
        fill: lyraSelectBaseColors.blueberry_25,
      },
      disabledIcon: {
        fill: lyraSelectBaseColors.blueberry_40,
      },
      progressBar: {
        fill: lyraSelectBaseColors.blueberry_30,
      },
    },
    wellnessGoalsOnboardingNavBar: {
      background: '#030331',
    },
    wellnessCheckInResultsDomainScore: {
      low: {
        outerCircle: {
          fill: lyraSelectBaseColors.red_50,
        },
        innerCircle: {
          fill: lyraSelectBaseColors.red_30,
        },
        text: lyraSelectBaseColors.red_30,
      },
      moderate: {
        outerCircle: {
          fill: lyraSelectBaseColors.gold_50,
        },
        innerCircle: {
          fill: lyraSelectBaseColors.gold_30,
        },
        text: lyraSelectBaseColors.gold_30,
      },
      high: {
        outerCircle: {
          fill: lyraSelectBaseColors.green_10,
        },
        innerCircle: {
          fill: lyraSelectBaseColors.green_30,
        },
        text: lyraSelectBaseColors.green_30,
      },
      default: {
        outerCircle: {
          fill: lyraSelectBaseColors.blueberry_60,
        },
        innerCircle: {
          fill: lyraSelectBaseColors.blueberry_50,
        },
        text: lyraSelectBaseColors.white,
      },
    },
    multicolorSliderField: {
      ...darkThemeColors.components.multicolorSliderField,
      track: {
        ...darkThemeColors.components.multicolorSliderField.track,
        minimumTint: { background: lyraSelectBaseColors.blueberry_70 },
        maximumTint: { background: lyraSelectBaseColors.blueberry_70 },
      },
    },
    triageSummary: {
      ...darkThemeColors.components.triageSummary,
      badge: {
        background: lyraSelectBaseColors.blueberry_60,
        fill: lyraSelectBaseColors.blueberry_30,
      },
    },
    sliderField: {
      ...darkThemeColors.components.sliderField,
      thumb: {
        ...darkThemeColors.components.sliderField.thumb,
        border: lyraSelectBaseColors.blueberry_30,
      },
      track: {
        ...darkThemeColors.components.sliderField.track,
        minimumTint: {
          background: lyraSelectBaseColors.blueberry_30,
        },
        maximumTint: {
          background: lyraSelectBaseColors.slider_background_tint_blue,
        },
      },
      floatingLabel: {
        ...darkThemeColors.components.sliderField.floatingLabel,
        border: lyraSelectBaseColors.blueberry_50,
      },
    },
    treatmentRecommendation: {
      background: lyraSelectBaseColors.blueberry_80,
    },
    treatmentCard: {
      ...darkThemeColors.components.treatmentCard,
      background: lyraSelectBaseColors.blueberry_70,
      findCounsellorSection: {
        icon: {
          fill: lyraSelectBaseColors.blueberry_60,
        },
      },
    },
    locationSearchNavigation: {
      ...darkThemeColors.components.locationSearchNavigation,
      highlightColor: { background: lyraSelectBaseColors.blueberry_40 },
    },
    s4cHeader: {
      ...darkThemeColors.components.s4cHeader,
      background: lyraSelectBaseColors.blueberry_75,
    },
    s4cTriageBackgroundHeader: {
      background: lyraSelectBaseColors.blueberry_75,
    },
    s4cTriageMaximumSliderTint: {
      background: lyraSelectBaseColors.slider_background_tint_blue,
    },
    twoColumnRegistrationLayout: {
      formBackground: {
        background: lyraSelectBaseColors.blueberry_80,
      },
      ssoDivider: {
        background: lyraSelectBaseColors.blueberry_40,
      },
    },
    internationalPhoneNumberEntry: {
      countryButtonAndPhoneInputBox: {
        background: lyraSelectBaseColors.blueberry_70,
      },
    },
    setupAccountForm: {
      submitButtonContainer: {
        background: lyraSelectBaseColors.blueberry_75,
      },
      formBodyPageContainer: {
        background: lyraSelectBaseColors.blueberry_75,
      },
    },
    wellnessCheckInResultsEssentialsCard: {
      background: lyraSelectBaseColors.blueberry_75,
    },
    onboardingNavBarDefaultBackground: {
      background: lyraSelectBaseColors.blueberry_70,
    },
  },
}
